// Boot-avslutning i riktig rekkefølge (WI 2118).
//
// Tidligere kjørte `main.js` `await router.replace(intendedRoute)` FØR
// `app.mount('#app')`. Login-ruten er lazy-lastet (`router/index.ts`), så den
// navigasjonen ventet på chunk-resolusjon + auth-guard-kjeden. Under en
// blokkert popup / treg rute-resolusjon resolverte den aldri → `app.mount()`
// ble aldri nådd → evig «Starter ICS…»-spinner, og boot-gaten
// (`markAppInteractive`) ble aldri armet.
//
// Rett rekkefølge: monter appen og arm den interaktive gaten FØRST (spinneren
// erstattes umiddelbart), naviger til en eventuell dyplenke ETTERPÅ — post-mount
// kan ikke fryse oppstarten. Navigasjons-feil swallow-es slik at en montert app
// aldri faller tilbake til spinneren.

const debugPrefix = "[main]";

export async function finalizeBoot (
  mountApp: () => void,
  markInteractive: () => void,
  navigateToIntended: () => Promise<unknown>
): Promise<void> {
  mountApp();
  markInteractive();
  try {
    await navigateToIntended();
  } catch (error) {
    console.warn(`${debugPrefix} Post-mount dyplenke-navigasjon feilet:`, error);
  }
}
